import { memo, FC } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';

interface ChipRightElementProps {
  onClickRemove?: () => void;
  isRemoveable?: boolean;
  value?: string;
  showRightElement?: boolean;
}

export const ChipRightElement: FC<ChipRightElementProps> = memo(
  ({ onClickRemove, isRemoveable = true, value = '', showRightElement = true }) => {
    const showRemoveIcon = isRemoveable && onClickRemove && value;
    const showCaretIcon = showRightElement;
    if (showRemoveIcon) {
      return (
        <Icon
          name='x-small'
          size={12}
          onClick={(e) => {
            e.stopPropagation();
            onClickRemove();
          }}
          css={rightElementStyle}
        />
      );
    }
    if (showCaretIcon) {
      return <Icon name='caret-down-small' size={12} css={rightElementStyle} />;
    }
    return null;
  }
);

ChipRightElement.displayName = 'ChipRightElement';

const rightElementStyle = css`
  margin-left: auto;
`;
